export const reminderEvents = {
  view_screen: "view_screen",
  select_button: "select_button",
};

export const baseReminderPayloadEvent = {
  user_type: "buyer",
  platform: "web",
};
